import { useContext, useEffect, useMemo, useState } from "react";
import { usePagination, useTable } from "react-table";
import { Get } from "../Rutas/ApiRest";
import "../index.css"
import { Rastreo, RastreoInicial } from "../Model/Tablas/RastreoCarga";
import { Contexto } from "../Context/Contexto";
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext";
import { tokens } from "../Context/Tokens";
import { Carga } from "../Rutas/Servicios";
import { Excel } from "../Componentes/Excel";
import { RastreoExcel } from "../Model/ExcelDTO";
import { Mostrar } from "../Context/Mostrando";
import { ReferenciaDTO } from "../Model/ReferenciaDTO";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";

function RastreosHistorial()
{
    const {tok}=useContext(tokens)
    const {Cli}=useContext(Contexto)
    const {GuiaBusqueda,SetGuiaBusquedaPreAlerta}=useContext(GuiaBusquedaCont)
    const {Actualizar}=useContext(Mostrar)
    const datos=[
        RastreoInicial
      ]
      const columns=useMemo(() => Rastreo, [])
      const dato=useMemo(() => datos, [])
      const [data,Setdata]=useState(dato)
      const {SetLoading2,Loading2}=useContext(MensajeContActualizacion)
      var cantidad=0
     useEffect(()=>{
        SetLoading2(true)
        ActualizarDatos();
     },[GuiaBusqueda])

     useEffect(()=>{
        SetLoading2(true)
        ActualizarDatos();
     },[Cli.Eleccion])

     const ActualizarDatos=()=>
     {
        if(Cli.lCasilla[Cli.Eleccion].ecode!=undefined)
        {
            if(Cli.lCasilla[Cli.Eleccion].ecode!="")
            {
                
                const historialcargas=Get(Carga.RastreoCarga.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode).replace("@guiahija",GuiaBusqueda),"application/json",tok)
                historialcargas.then(resultado=>{Setdata(resultado);SetLoading2(false)})
            }else
            {
                SetLoading2(false)
            }
        }else
            {
                SetLoading2(false)
            }

     }

          const {
            getTableProps, 
            getTableBodyProps, 
            headerGroups, 
            page,
            nextPage,
            previousPage,
            canNextPage,
            canPreviousPage,
            pageOptions,
            gotoPage,
            pageCount,
            setPageSize,
            state,
            prepareRow,
        } = useTable({
                // @ts-ignore
                columns,
                data,
            },
            usePagination
        );

        const { pageIndex,pageSize } = state
    return (
        <>
        {data.length===0?<div><div className="alert au-alert-success alert-dismissible fade show au-alert au-alert--100per" role="alert" id="One"> <span className="content" >No existen cargas disponibles.</span>

                    </div></div>:<> <div className="row">
            <div className="col-12 py-2 py-sm-0">
              <div className="table-responsive" id="RastreoBusqueda">
                     <table  {...getTableProps()} className="table table-hover table-sm table-bordered" id="rastroBusqueda">
                       <thead style={{verticalAlign:"middle"}}>
                           {headerGroups.map((headerGroup) => (
                               <tr {...headerGroup.getHeaderGroupProps()}>
                                   {headerGroup.headers.map((column) => (
                                       <th {...column.getHeaderProps()}>
                                           {column.render('Header')}
                                       </th>
                                   ))}
                               </tr>
                           ))}
                       </thead>

                       <tbody {...getTableBodyProps()} style={{verticalAlign:"top",textAlign:"center"}}>
                           {page.map((row: any) => {
                               prepareRow(row)
                               
                               let colore="#0d6efd"
                               let guias=""
                                if(row.cells[0].value===GuiaBusqueda+"")
                                {
                                    colore="#FFD700"
                                }
                                
                               return (
                                   <tr {...row.getRowProps()} style={{background:row.cells[0].value===GuiaBusqueda+""?"#00ad5f":"",color:row.cells[0].value===GuiaBusqueda+""?"#fff":""}}>
                                       {row.cells.map((cell: any) => {
                                        var datoss=""
                                        
                                        if(cell.column.Header==="Imagenes" && cell.value!=undefined && cell.value!="-")
                                        {
                                          datoss=cell.value.split(',')
                                          cantidad=cantidad+1
                                        }

                                        if(cell.column.Header==="No. de Guía" )
                                        {
                                            guias=cell.value
                                        }
                                           return (
                                            cell.column.Header==="Factura" && cell.value!="-" && cell.value !=undefined?
                                            cell.value.includes("Public/aduana?")?<td {...cell.getCellProps()}><a onClick={()=>Actualizar(ReferenciaDTO.UbicacionDocumentacion)} style={{cursor:"pointer"}} target="_blank" rel="noopener noreferrer"><i className="bi-search" style={{color:"black"}}></i></a></td>:
                                            <td {...cell.getCellProps()}><a onClick={()=>{Actualizar(ReferenciaDTO.UbicacionSinFactura);SetGuiaBusquedaPreAlerta(guias)}} style={{cursor:"pointer"}} target="_blank" rel="noopener noreferrer"><i className="bi-search" style={{color:"black"}}></i></a></td>
                                            : cell.column.Header==="Imagenes" && cell.value!="-"?
                                            datoss.length==2?<td {...cell.getCellProps()}>
                                                <a className="nav-link collapsed" data-bs-target={"#components-n"+cantidad} data-bs-toggle="collapse" style={{cursor:"pointer",color:colore}}>Imagenes</a>
                                                    <ul id={"components-n"+cantidad} className="nav-content collapse" data-bs-parent="#sidebar-nav" style={{padding:"0"}}>
                                                         {datoss[0]!="-"?<div style={{paddingBottom:"20px"}}><a href={"https://apps.eshopex.cl/admin_sac/desconsolidador/getArchive?nombreArchivo="+datoss[0]} style={{color:colore}}> {datoss[0]} </a></div>  :null}
                                                         {datoss[1]!="-"?<a  href={"https://apps.eshopex.cl/admin_sac/desconsolidador/getArchive?nombreArchivo="+datoss[1]} style={{color:colore}}> {datoss[1]} </a> :null}
                                                    </ul>
                                                    
                                                </td>:
                                            <td {...cell.getCellProps()} >-</td>
                                            :<td {...cell.getCellProps()} >{cell.render('Cell')}</td>
                                        );
                                    })}
                                   </tr>
                               );
                           })}
                       </tbody>
                   </table>   
              </div>
			  </div>
             
            
		  </div>
          {data.length>10?<>
            <div className="col-12 py-2 py-sm-0"><div className="col-sm-12">
            <div className="row">
                <div className="col-sm-9 my-1 px-sm-2">
                <div className="table-pagination" style={{margin: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
<a href={"#Rastreo"}>
<button onClick={() => previousPage()} disabled={!canPreviousPage} className="btn btn-success">
                        Anterior
                    </button>
                   
                   
                </a>
                
                <span>
                    <strong style={{display: 'block', width: '100px', textAlign: 'center'}}>
                        {pageIndex + 1} / {pageOptions.length} 
                    </strong>
                </span>
                
                <a >
                <button onClick={() => nextPage()} disabled={!canNextPage} className="btn btn-success" >
                        Siguiente
                    </button>
                    
                   
                   
                </a>
               
            </div>
                </div>
                <div className="col-sm-2 my-1 px-sm-2">
                    <div style={{margin: '5px', justifyContent: 'center', alignItems: 'center'}}>
                        <span>Ver Filas </span> <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}  >
                    {
                        [10,25,50, 100].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                {pageSize}
                            </option>
                        ))
                    }
                </select>
                    </div>
                
                </div>
                </div></div> </div></>:null}

<br/>
              <div className="table-pagination" >
                <a>
                    <Excel contenido={RastreoExcel}></Excel>
                </a>
            </div>
        </>
                    }


            
            
        </>
    )
}

export default RastreosHistorial;